import React from "react"
import Icon from "@ant-design/icons"

const linkIconSvg = (props: { color?: string }) => (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4.53025 8.50781L2.09455 9.91406C1.01839 10.5354 0.649676 11.9115 1.271 12.9876L2.11475 14.449C2.73607 15.5252 4.11214 15.8939 5.1883 15.2726L7.624 13.8663C8.70016 13.245 9.06888 11.8689 8.44756 10.7928L7.60381 9.33137C6.98249 8.25521 5.60641 7.88649 4.53025 8.50781Z"
            stroke={props.color || "white"}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.8115 3.72656L10.3758 5.13281C9.29964 5.75413 8.93093 7.13021 9.55225 8.20637L10.396 9.66779C11.0173 10.7439 12.3934 11.1127 13.4696 10.4913L15.9052 9.08509C16.9814 8.46377 17.3501 7.0877 16.7288 6.01154L15.8851 4.55012C15.2637 3.47396 13.8877 3.10524 12.8115 3.72656Z"
            stroke={props.color || "white"}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M5.10303 11.75L12.8973 7.25" stroke="white" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

interface LinkIconProps extends Omit<React.ComponentProps<typeof Icon>, "component"> {
    color?: string
}

export const LinkIcon = (props: LinkIconProps) => <Icon component={() => linkIconSvg({ color: props.color })} {...props} />
